import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '../features/auth/ResetPasswordPage';
import { resetPasswordRouteSearchSchema } from '../features/auth/resetPasswordRouteSearch';

export const Route = createFileRoute('/reset-password')({
  validateSearch: resetPasswordRouteSearchSchema,
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  return <ResetPasswordPage token={token} />;
}
